export type BlogPathway = {
 id: string;
 label: string;
 bookSlug: string;
 description: string;
};

export const UNTANGLED_BLOG_PATHWAYS: BlogPathway[] = [
 {
 id: 'modern-dating',
 label: 'Modern Dating',
 bookSlug: 'please-dont-say-you-love-me',
 description: 'Apps, mixed signals, validation, red flags, intimacy, boundaries, and conscious connection.',
 },
 {
 id: 'ai-social-love',
 label: 'AI, Social Media & Love',
 bookSlug: 'the-perfect-delusion',
 description: 'Algorithms, synthetic perfection, digital validation, AI replies, and the pressure to perform love online.',
 },
 {
 id: 'manipulation-self-trust',
 label: 'Manipulation & Self-Trust',
 bookSlug: 'the-unsettling-feeling',
 description: 'Gaslighting, guilt, love bombing, blame shifting, silence, and the slow return of self-trust.',
 },
 {
 id: 'trauma-bond-recovery',
 label: 'Trauma Bond Recovery',
 bookSlug: 'untangling-the-spark',
 description: 'The spark, the echo, withdrawal, grief, no contact or low contact, and rebuilding self-worth.',
 },
 {
 id: 'womanhood-homecoming',
 label: 'Womanhood & Homecoming',
 bookSlug: 'finding-your-path-home',
 description: 'Scripts, success, love, loneliness, marriage, motherhood, partnership, and choosing a life that feels honest.',
 },
];

